"use client";

import Nav from "../NavList"; 
import TeamCard from "./TeamCard";
import CoverImage from "../CoverImage";

const Teams = () => {
  return (
    <>
      <CoverImage />

      <Nav />

      <TeamCard />
    </>
  );
};

export default Teams;
